export const plans2 = [
  {
    id: 'PLAN0000',
    title: 'Başlangıç',
    price: 0,
    description: 'İşletmeniz için ücretsiz QR menu oluşturmanızı sağlar',
    features: [
      'QR menu',
      '50 Ürün',
      '10 kategori',
      '2 Tema',
      'Subdomain uzantı',
    ],
    limits: {
      storage: 5 * 1000000, // 5 MB
      product: 70,
      category: 10,
      branch: 1,
      menu: 5,
    },
  },
  {
    id: 'PLAN0001',
    title: 'İleri',
    price: 350,
    description:
      'İşletmeniz için başlangıç seviye QR menu oluşturmanızı sağlar',
    features: [
      'QR menu',
      'Sınırsız Ürün',
      'Sınırsız kategori',
      '10 Tema',
      'Subdomain uzantı',
      'Ücretsiz Teknik Destek',
    ],
    limits: {
      storage: 50 * 1000000, // 50 MB
      product: 200,
      category: 20,
      branch: 1,
      menu: 20,
    },
  },
  {
    id: 'PLAN0002',
    title: 'Profesyonel',
    price: 800,
    description: 'İşletmeniz için profesyonel QR menu oluşturmanızı sağlar',
    features: [
      'QR menu',
      'Sınırsız Ürün',
      'Garson Çağırma',
      'Sipariş fişi yazdırma',
      'Hesap iste',
      'Şube sistemi (her şube için ayrı menü)',
      '20 Tema',
      'Dilek öneri şikayet bölümü',
      'Subdomain uzantı',
      'Ücretsiz Teknik Destek',
    ],
    limits: {
      storage: 200 * 1000000, // 200 MB
      product: 999,
      category: 30,
      branch: 30,
      menu: 100,
    },
  },
  {
    id: 'PLAN0003',
    title: 'Özel',
    price: 2500,
    description:
      'İşletmeniz için sizin isterleriniz doğrultusunda QR menu oluşturmanızı sağlar',
    features: [
      'QR menu',
      'Sınırsız Ürün',
      'Garson Çağırma',
      'Sipariş fişi yazdırma',
      'Hesap iste',
      'Masadan sipariş',
      'Rezervasyon yap',
      '20 Tema + 1 özel tema',
      'Dilek öneri şikayet bölümü',
      'Subdomain ve Domain uzantı',
      'Ücretsiz Teknik Destek',
    ],
  },
];

export const plans = [
  {
    id: 'PLAN0010',
    title: 'ÜCRETSİZ',
    order: 1,
    price: 0,
    description:
      'İşletmeniz için sınırlı özelliklere sahip sipariş sayfasına sahip olursunuz',
    features: [
      'Sınırsız Trafik',
      '1 Yönetici Hesabı',
      'Aylık 100 sipariş',
      '100 MB Hafıza',
    ],
  },
  {
    id: 'PLAN0030',
    title: 'Giriş',
    order: 2,
    price: 1000,
    description: 'İşletmeniz için hızlı sipariş sayfasına sahip olursunuz',
    features: [
      'Sınırsız Trafik',
      '1 Yönetici Hesabı',
      '1 Sipariş Takip Hesabı',
      'Aylık 1.000 sipariş',
      'E-Posta Bildirimi',
      '1 GB Hafıza',
      'Destek',
    ],
  },
  {
    id: 'PLAN0050',
    title: 'Gelişmiş',
    order: 3,
    price: 5000,
    description:
      'Siparişleri kolay yönettiğiniz bir sipariş sisteme sahip olursunuz.',
    features: [
      'Sınırsız Trafik',
      'Giriş plandakilerin tümü',
      'Menü Kolay Profesyonel Paketi Hediye',
      'Özel Domain (.com, .net, vb.)',
      'Çoklu Dil Desteği',
      '+1 Yönetici Hesabı',
      '2 Sipariş Takip Hesabı',
      'Aylık 5.000 Sipariş',
      '5 GB Hafıza',
      'Öncelikli Destek',
    ],
  },
  {
    id: 'PLAN0080',
    title: 'Özel',
    order: 4,
    price: 20000,
    description:
      'Siparişleri analiz edip arttırdığınız bir sipariş sisteme sahip olursunuz.',
    features: [
      'Sınırsız Trafik',
      'Gelişmiş plandakilerin tümü',
      'Özel Domain (.com, .net, vb.)',
      'Çoklu Şube Desteği',
      '+2 Yönetici Hesabı',
      'Sınırsız Siparis Takip Hesabı',
      'Sınırsız Kurye Hesabı',
      '50 GB Hafıza',
      'Sınırsız Aylık Sipariş',
      'Öncelikli Destek',
    ],
  },
];
